import React from 'react'
import NabBar from '../Navbar/NabBar'
import Footer from '../Footer/Footer'
import './PageShell.scss';

/*
 * Shared frame for the public pages (About, Contact, Plans).
 * Navbar, a dark gradient masthead, the page body, then the footer -
 * so the three pages open the same way and share one type scale.
 */
const PageShell = ({ eyebrow, title, lede, art, children }) => (
    <div className="pg">
        <NabBar />

        <header className="pg-hero">
            <span className="pg-hero-glow" aria-hidden="true" />
            <div className="container">
                <div className="pg-hero-grid">
                    <div className="pg-hero-copy">
                        <p className="pg-eyebrow">{eyebrow}</p>
                        <h1 className="pg-title">{title}</h1>
                        {lede && <p className="pg-lede">{lede}</p>}
                    </div>
                    {art && <div className="pg-hero-art">{art}</div>}
                </div>
            </div>
        </header>

        <main>{children}</main>

        <Footer />
    </div>
);

export default PageShell
